import { useMarkNotificationsRead, useNotifications } from '../api/hooks'
import { NotificationList } from '../components/NotificationList'
import type { AtlasNotification } from '../api/types'
import { Button, EmptyState, ErrorNotice, Loading, PageHeader } from '../components/ui'

/** The bell panel shows the last 20. This is the rest of them. */
const PAGE_LIMIT = 100

export function NotificationsPage() {
  const { data, isLoading, error } = useNotifications(PAGE_LIMIT)
  const markRead = useMarkNotificationsRead()

  const unread = data?.filter((n) => n.readAt === null).length ?? 0

  function handleOpenRow(notification: AtlasNotification) {
    if (notification.readAt === null) markRead.mutate({ ids: [notification.id] })
  }

  return (
    <div>
      <PageHeader
        title="Notifications"
        subtitle="What has landed on you. Atlas keeps three months and never sends email."
        actions={
          unread > 0 ? (
            <Button onClick={() => markRead.mutate({ all: true })} loading={markRead.isPending}>
              Mark all read
            </Button>
          ) : undefined
        }
      />

      {isLoading && <Loading />}
      {error && <ErrorNotice error={error} />}

      {data && data.length === 0 && (
        <EmptyState
          title="Nothing yet"
          description="You will be told here when work is assigned to you, when a due date moves, and when a meeting you are in is booked, changed or cancelled."
        />
      )}

      {data && data.length > 0 && (
        <div className="card overflow-hidden">
          <NotificationList notifications={data} onOpen={handleOpenRow} />
        </div>
      )}
    </div>
  )
}
